/** Where a report opens: the full report page, a new browser tab, or the hub's side peek. */
export type ReportOpenMode = "page" | "new-tab" | "peek";

export type OpenPreflightReportOptions = { mode?: ReportOpenMode };

export const MIDDLE_MOUSE_BUTTON = 1;

interface OpenGesture {
  metaKey: boolean;
  ctrlKey: boolean;
  /** Absent on keyboard events. */
  button?: number;
}

/**
 * Cmd-click, Ctrl-click and middle-click mean "new tab" in every browser. Rows and headers
 * that navigate in JS honour the same gestures a real link would.
 */
export function isNewTabIntent(gesture: OpenGesture): boolean {
  return (
    gesture.metaKey ||
    gesture.ctrlKey ||
    gesture.button === MIDDLE_MOUSE_BUTTON
  );
}

/** A plain activation opens the full page; a new-tab gesture keeps the hub in place. */
export function toOpenMode(gesture: OpenGesture): ReportOpenMode {
  return isNewTabIntent(gesture) ? "new-tab" : "page";
}
